<ul nz-menu>
  <li
    (click)="timelineUserRowContextMenuWrapperService.createEmptyShift()"
    nz-menu-item
  >
    {{ 'page.shift_timeline.empty_shift' | translate }}
  </li>
  <li
    (click)="timelineUserRowContextMenuWrapperService.createNewAbsence()"
    nz-menu-item
  >
    {{ 'enum.absence_category.rest-day' | translate }}
  </li>
  <li (click)="openShiftTemplateSelectionModalAndCreate()" nz-menu-item>
    {{ 'page.shift_timeline.shift_templates_tab' | translate }}
  </li>
</ul>
